// base_info_view.js
import React, { Children, use, useRef, useState } from 'react'
import BaseInfoView1 from "./base_info_view_1"
import BaseInfoView2 from "./base_info_view_2"
import BaseInfoView3 from "./base_info_view_3"
import BaseInfoView4 from "./base_info_view_4"
import BaseInfoView5 from "./base_info_view_5"
import BaseInfoView6 from "./base_info_view_6"
import { BaseTreeSelector } from './base_tree_selector.jsx'
import {
    useCRUDController, Button, Row, Col, ProTableOt,
    useProTableOt, setParamsFilter, message, DeleteButton
} from './ot'
import { LayoutGrid, List, TableIcon } from "lucide-react"
import { cn } from './utils'
import { useEffect } from 'react'
const BaseInfoView = ({
    reloadCount = 0,
    reloadAndResetCount = 0,
    rowKey = "document_id",
    showComponent = [
        "BaseInfoView1",
        "BaseInfoView2",
        "BaseInfoView3",
        // "BaseInfoView4",
        "BaseInfoView5",
        "BaseInfoView6",
        "BaseTreeSelector", //樹狀篩選

    ],
    apiRoute = "/utility/document/base_on_classify_structure",
    extraTabsKey = [],
    categoryData = [
        {
            key: "empty_draft",
            label: "進行中/歷史 空白建立",
            dark_mode_color: "#60a5fa",
            light_mode_color: "#f0f6ff",
            children: [
                {
                    key: "ing",
                    label: "進行中",
                    dark_mode_color: "#60a5fa",
                    light_mode_color: "#f0f6ff",
                },
                {
                    key: "history",
                    label: "歷史",
                    dark_mode_color: "#60a5fa",
                    light_mode_color: "#f0f6ff",
                },
            ]
        },
        {
            key: "ai_generated",
            label: "進行中/歷史 AI生成",
            dark_mode_color: "#6B21BD",
            light_mode_color: "#f3e8ff",
            children: [
                {
                    key: "ing",
                    label: "進行中",
                    dark_mode_color: "#6B21BD",
                    light_mode_color: "#f3e8ff",
                },
                {
                    key: "history",
                    label: "歷史",
                    dark_mode_color: "#6B21BD",
                    light_mode_color: "#f3e8ff",
                },
            ]
        },
        {
            key: "system_default",
            label: "進行中/歷史 系統預設",
            dark_mode_color: "#176634",
            light_mode_color: "#c8e6c9",
            children: [
                {
                    key: "ing",
                    label: "進行中",
                    dark_mode_color: "#176634",
                    light_mode_color: "#c8e6c9",
                },
                {
                    key: "history",
                    label: "歷史",
                    dark_mode_color: "#176634",
                    light_mode_color: "#c8e6c9",
                },
            ]
        }
    ],

    baseInfoView1Props = {
        baseInfoView1_1Props: {
            keywordPlaceholder: "關鍵字",
            defaultKeyword: "",
            conditionOptions: { 類別: ["通知信", "簡報"], 狀態: ["草稿", "已發佈"] },
            defaultConditions: {},
            advancedFields: [
                {
                    label: "名稱",
                    name: "document_name",
                    type: "text"
                },
                {
                    label: "描述",
                    name: "document_description",
                    type: "text"
                },
                {
                    label: "建立日期",
                    name: "create_time",
                    type: "date_range"
                },
                // {
                //     label: "建立日期（迄）",
                //     name: "create_time_end",
                //     type: "date_range"
                // },
            ],
            defaultAdvancedValues: {

            },
            searchButtonText: '查詢',
            showConditionFilter: false,
            showAdvancedButton: true,
            onSearch: () => { },
            onKeywordChange: () => { },
        }
    },
    baseInfoView2Props = {
        baseInfoView2_1Props: {
            button_data: [
                {
                    label: "卡片模式",
                    icon: <LayoutGrid className="h-4 w-4" />,
                    key: "卡片模式"
                },
                {
                    label: "列表模式",
                    icon: <List className="h-4 w-4" />,
                    key: "列表模式"
                },
                // 需要再打開
                // { 
                //     label: "表格模式",
                //     icon: <TableIcon className="h-4 w-4" />,
                //     key: "表格模式"
                // }
            ],
            defaultActiveKey: "卡片模式",
            onChange: () => { }
        },
        showComponent: ["BaseInfoView2_1"]
    },
    baseInfoView3_1Props = {
        showAllLabel: true,
    },
    baseInfoView4Props = {
        multipleCheckBox: true,
        baseInfoView4_1_props: {
            baseActionList: ["批次刪除"],
        },
        baseInfoView4_2_props: {
            orderColumns: [
                {
                    label: "文案名稱",
                    value: "template_name"
                },
                {
                    label: "文案描述",
                    value: "template_description"
                },
                {
                    label: "瀏覽次數",
                    value: "view_times"
                },
                {
                    label: "點擊次數",
                    value: "click_times"
                },
                {
                    label: "複製次數",
                    value: "copy_times"
                },
                {
                    label: "復用次數",
                    value: "clone_times"
                },
            ]
        }
    },
    baseInfoView5Props = {
        baseInfoView5_1props: {
            rowKey: rowKey,
        }
    },
    baseInfoView6Props = {
    },
    baseTreeSelectorProps = {
        title: "分類篩選",
        filterComponentCols: 6,
        data: [],
        onChange: () => { },
        showCount: true,
    },
    proptableDefaultProps = {
        columns: [

        ]
    },
    toolBarRender = () => {
        return [];
    },
    getBaseCardViewData = (apiData) => {
        return apiData
    },
    getBaseListViewData = (apiData) => {
        return apiData
    },
    getTableViewData = (apiData) => {
        // data total
        return apiData
    },
    getParams: propsGetParams = (keyArr = [], categoryDataValue) => { return null },
    onTabChange = () => { }, // 切換分類時的回調 
    extraButtonRender = () => { return [] },
    tabSelectRowKeys = {}, // { tabKey: [rowKey1, rowKey2] }
    onSelectChange = () => { }, // (selectedRows, categoryKey) => {}  categoryKey 可用於辨識是在哪個分類下的選擇變化
    propsRequest, // 覆蓋整個 InfoView 的 request，參數同 InfoView 的 request 參數  
}) => {
    const [viewMode, setViewMode] = useState(baseInfoView2Props?.baseInfoView2_1Props?.defaultActiveKey || "卡片模式")
    const [categoryMode, setCategoryMode] = useState(categoryData?.find((_) => true)?.key || "")
    const [keyword, setKeyword] = useState(baseInfoView1Props?.baseInfoView1_1Props?.defaultKeyword || null)
    const [advancedSearch, setAdvancedSearch] = useState({})
    const [loadings, setLoadings] = useState(Object.fromEntries(categoryData.map(item => [item.key, false])))
    // const [reloadCount, setReloadCount] = useState(0)
    // const [reloadAndResetCount, setReloadAndResetCount] = useState(0)
    const [searchCount, setSearchCount] = useState(0)
    const [selectedRows, setselectedRows] = useState([])
    const [infoViewTotals, setInfoViewTotals] = useState({})
    const [infoViewSelections, setInfoViewSelections] = useState({})
    const categoryToBaseInfoView3PropsData = (categoryData) => {
        let data = categoryData?.map((value) => {
            return {
                key: value?.key,
                label: value?.label,
                total: "0/0", // 雙數字
                ...value
            }
        })
        return data
    }
    const dataController = useCRUDController({
        apiRoute: apiRoute,
        onBefore: ({ }) => {

        },
        onFinish: ({ }) => {

        }
    })
    const request = async (params = {}, sort, filter) => {
        return dataController.getData({ ...params, sort, filter })
    };
    // useEffect(() => {
    //     if (categoryData) {
    //         setCategoryMode(categoryData?.find((_) => true)?.key || "") // 預設第一個 key
    //     }
    // }, [categoryData])
    // 一般搜尋 、進階搜尋 、條件過濾 1hr、分頁切換、勾選筐（全選、取消全選）、2hr 半天
    const getParams = (...e) => {
        let params = propsGetParams(...e)
        return {
            ...params,
            ...advancedSearch,
            keyword,
        }
    }

    const tabLabel = categoryData?.find(item => item?.key == categoryMode)?.label
    const TabComponent = extraTabsKey?.find(item => item?.key == tabLabel)?.component
    return (<>
        <div className="space-y-6">

            {/* 搜索和篩選區域 */}
            <div className="space-y-4">
                {/* 頂部工具列 */}
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">

                    {/* 左側：搜尋框獨立一區 */}
                    <div className="flex items-center gap-2">
                        {showComponent.includes("BaseInfoView1") && (
                            <BaseInfoView1
                                {...baseInfoView1Props}
                                baseInfoView1_1Props={{
                                    ...baseInfoView1Props?.baseInfoView1_1Props,
                                    defaultKeyword: keyword,
                                    onSearch: (search = {}) => {
                                        setAdvancedSearch(search)
                                        setSearchCount((pre) => pre + 1)
                                    },
                                    onKeywordChange: (value) => {
                                        setKeyword(value)
                                    }
                                }}
                            />
                        )}
                    </div>

                    {/* 右側：按鈕群組靠右對齊 */}
                    <div className="flex items-center gap-2 ml-auto">
                        {[...toolBarRender()].map((ele, idx) => (
                            <span key={idx}>{ele}</span>
                        ))}
                        {showComponent.includes("BaseInfoView2") && (
                            <BaseInfoView2
                                baseInfoView2_1Props={{
                                    button_data: [
                                        {
                                            label: "卡片模式",
                                            icon: <LayoutGrid className="h-4 w-4" />,
                                            key: "卡片模式"
                                        },
                                        {
                                            label: "列表模式",
                                            icon: <List className="h-4 w-4" />,
                                            key: "列表模式"
                                        }
                                    ],
                                    defaultActiveKey: "卡片模式",
                                    ...baseInfoView2Props?.baseInfoView2_1Props,
                                    onChange: (value) => {
                                        setViewMode(value)
                                    },
                                }}
                            />
                        )}
                    </div>
                </div>

                {/* 分類標籤（只在歷史圖框樣式模式下顯示） */}
                {showComponent.includes("BaseInfoView3") && (
                    <BaseInfoView3
                        baseInfoView3_1Props={{
                            data: categoryToBaseInfoView3PropsData(categoryData),
                            allLabel: "全部",
                            total: 0,
                            defaultValue: baseInfoView3_1Props?.showAllLabel ? "" : categoryToBaseInfoView3PropsData(categoryData).find((_) => true)?.key || "",
                            onChange: (value) => {
                                onTabChange(value);
                                setCategoryMode(value)
                            },
                            ...baseInfoView3_1Props
                        }}
                        showComponent={["BaseInfoView3_1"]}
                    />
                )}
            </div>
            {/* 根目錄 (全部展開)時出現 第一層checkbox*/}
            {categoryMode === "" && (
                <Col span={24}>
                    {showComponent.includes("BaseInfoView4") && (
                        <BaseInfoView4
                            {...baseInfoView4Props}
                            baseInfoView4_1_props={{
                                ...baseInfoView4Props?.baseInfoView4_1_props,
                                showComponent: ["BaseBulkActionControl1_2", "BaseBulkActionControl1_3"],
                            }}
                            showComponent={['BaseInfoView4_1']}
                        />
                    )}
                </Col>
            )}

            {TabComponent === undefined && categoryData.filter((element) => {
                if (categoryMode === "") {
                    return true;
                } else {
                    return element?.key === categoryMode;
                }
            })?.map((values, index) => {
                const hasChildren = values?.children && values.children.length > 0;
                const isRootMode = categoryMode === "";
                // === 根目錄 (全部展開), 顯示一次 BaseInfoView4
                if (isRootMode) {
                    return (
                        <Row key={values.key} gutter={[4, 4]}>
                            {showComponent.includes("BaseTreeSelector") && (
                                <Col
                                    xxl={baseTreeSelectorProps?.filterComponentCols}
                                    xl={baseTreeSelectorProps?.filterComponentCols}
                                    lg={baseTreeSelectorProps?.filterComponentCols}
                                    md={baseTreeSelectorProps?.filterComponentCols}
                                    sm={baseTreeSelectorProps?.filterComponentCols}
                                    xs={24}
                                    className={"mb-2"}>
                                    <BaseTreeSelector {...baseTreeSelectorProps} />
                                </Col>
                            )}
                            <Col
                                xxl={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                xl={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                lg={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                md={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                sm={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                xs={24}
                            >
                                <InfoView
                                    reloadAndResetCount={reloadAndResetCount}
                                    reloadCount={reloadCount}
                                    params={getParams([values?.key], values, keyword)}
                                    showComponent={showComponent}
                                    values={values}
                                    baseInfoView4Props={baseInfoView4Props}
                                    baseInfoView5Props={baseInfoView5Props}
                                    baseInfoView6Props={baseInfoView6Props}
                                    viewMode={viewMode}
                                    apiRoute={values?.apiRoute ? values?.apiRoute : apiRoute}
                                    getBaseCardViewData={getBaseCardViewData}
                                    getBaseListViewData={getBaseListViewData}
                                    getTableViewData={getTableViewData}

                                    searchCount={searchCount}
                                    rowKey={rowKey}
                                    onTotalChange={(total) => {
                                        setInfoViewTotals(prev => ({ ...prev, [values?.key]: total })) // or values.key
                                    }}
                                    onSelectChange={(rows) => {
                                        onSelectChange(rows, values?.key)
                                        setInfoViewSelections(prev => ({ ...prev, [values?.key]: rows })) // or values.key
                                    }}
                                    proptableDefaultProps={proptableDefaultProps}
                                    extraButtonRender={extraButtonRender}
                                    propsSelectRowKeys={tabSelectRowKeys?.[values?.key] || []}
                                    propsRequest={propsRequest}
                                />
                            </Col>
                        </Row>
                    );
                }

                // === 指定分類，且有 children 時，對每個 children 顯示 InfoView
                // if (!isRootMode && hasChildren) {
                //     const childTotal = values.children.reduce((sum, child) => {
                //         return sum + (infoViewTotals[child.key] || 0)
                //     }, 0)

                //     const childSelectedCount = values.children.reduce((sum, child) => {
                //         return sum + ((infoViewSelections[child.key] || []).length)
                //     }, 0)
                //     return (
                //         <Row key={values.key}>
                //             {
                //                 /* 第二層的checkbox */
                //                 <Col span={24}>
                //                     {showComponent.includes("BaseInfoView4") && (
                //                         <BaseInfoView4
                //                             {...baseInfoView4Props}
                //                             baseInfoView4_1_props={{
                //                                 ...baseInfoView4Props?.baseInfoView4_1_props,
                //                                 showComponent: ["BaseBulkActionControl1_2", "BaseBulkActionControl1_3"],
                //                                 selectedTotal: childTotal,
                //                                 selectedCount: childSelectedCount
                //                             }}
                //                             showComponent={['BaseInfoView4_1']}

                //                         />
                //                     )}
                //                 </Col>
                //             }
                //             {/* children 分開顯示 */}
                //             <Col span={24}>
                //                 <Row gutter={[4, 4]}>
                //                     {values?.children.map((val) => {
                //                         return (
                //                             <Col span={24} key={val.key}>
                //                                 <InfoView
                //                                     reloadAndResetCount={reloadAndResetCount}
                //                                     reloadCount={reloadCount}
                //                                     params={getParams([values?.key, val?.key], values)}
                //                                     showComponent={showComponent}
                //                                     values={val}
                //                                     baseInfoView4Props={baseInfoView4Props}
                //                                     baseInfoView5Props={baseInfoView5Props}
                //                                     baseInfoView6Props={baseInfoView6Props}
                //                                     viewMode={viewMode}
                //                                     apiRoute={values?.apiRoute ? values?.apiRoute : apiRoute}

                //                                     getBaseCardViewData={getBaseCardViewData}
                //                                     getBaseListViewData={getBaseListViewData}
                //                                     getTableViewData={getTableViewData}
                //                                     searchCount={searchCount}
                //                                     rowKey={rowKey}
                //                                     onTotalChange={(total) => {
                //                                         setInfoViewTotals(prev => ({ ...prev, [val.key]: total })) // or values.key
                //                                     }}
                //                                     onSelectChange={(rows) => {
                //                                         setInfoViewSelections(prev => ({ ...prev, [val.key]: rows })) // or values.key
                //                                     }}
                //                                     proptableDefaultProps={proptableDefaultProps}
                //                                 />
                //                             </Col>
                //                         )
                //                     })}
                //                 </Row>
                //             </Col>
                //         </Row>
                //     );
                // }

                // === 指定分類，且無 children，顯示一次 BaseInfoView4 + 一個 InfoView
                return (
                    <Row key={values.key}>
                        {/* 第二層的checkbox */}

                        {!baseInfoView4Props?.multipleCheckBox && showComponent.includes("BaseInfoView4") && (

                            <Col span={24}>
                                <BaseInfoView4
                                    {...baseInfoView4Props}
                                    baseInfoView4_1_props={{
                                        ...baseInfoView4Props?.baseInfoView4_1_props,
                                        showComponent: ["BaseBulkActionControl1_2", "BaseBulkActionControl1_3"],
                                        selectedTotal: 10,
                                        selectedCount: 10
                                    }}
                                    showComponent={['BaseInfoView4_1']}

                                />
                            </Col>
                        )}
                        <Col span={24}>
                            <Row key={values.key} gutter={[4, 4]}>
                                {showComponent.includes("BaseTreeSelector") && (
                                    <Col
                                        xxl={baseTreeSelectorProps?.filterComponentCols}
                                        xl={baseTreeSelectorProps?.filterComponentCols}
                                        lg={baseTreeSelectorProps?.filterComponentCols}
                                        md={baseTreeSelectorProps?.filterComponentCols}
                                        sm={baseTreeSelectorProps?.filterComponentCols}
                                        xs={24}
                                        className={"mb-2"}>
                                        <BaseTreeSelector {...baseTreeSelectorProps} />
                                    </Col>
                                )}
                                <Col
                                    xxl={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                    xl={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                    lg={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                    md={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                    sm={showComponent.includes("BaseTreeSelector") ? 24 - baseTreeSelectorProps?.filterComponentCols : 24}
                                    xs={24}
                                >
                                    <InfoView
                                        reloadAndResetCount={reloadAndResetCount}
                                        reloadCount={reloadCount}
                                        params={getParams([values?.key], values, keyword)}
                                        showComponent={showComponent}
                                        values={values}
                                        baseInfoView4Props={baseInfoView4Props}
                                        baseInfoView5Props={baseInfoView5Props}
                                        baseInfoView6Props={baseInfoView6Props}
                                        viewMode={viewMode}
                                        apiRoute={values?.apiRoute ? values?.apiRoute : apiRoute}
                                        getBaseCardViewData={getBaseCardViewData}
                                        getBaseListViewData={getBaseListViewData}
                                        getTableViewData={getTableViewData}
                                        searchCount={searchCount}
                                        rowKey={rowKey}
                                        onTotalChange={(total) => {
                                            setInfoViewTotals(prev => ({ ...prev, [values.key]: total })) // or values.key
                                        }}
                                        onSelectChange={(rows) => {
                                            onSelectChange(rows, values?.key)
                                            setInfoViewSelections(prev => ({ ...prev, [values.key]: rows })) // or values.key
                                        }}
                                        proptableDefaultProps={proptableDefaultProps}
                                        extraButtonRender={extraButtonRender}
                                        propsSelectRowKeys={tabSelectRowKeys?.[values?.key] || []}
                                        propsRequest={propsRequest}

                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                );
            })}

            {TabComponent && <>
                <TabComponent
                    {...(
                        {
                            key: categoryMode,
                            apiRoute: categoryData?.find(item => item?.key == categoryMode)?.apiRoute,
                        }
                    )}
                    params={{ ...getParams([categoryData?.find(element => element?.key === categoryMode)?.key], categoryData?.find(element => element?.key === categoryMode)), keyword }}
                    getBaseCardViewData={getBaseCardViewData}
                    getBaseListViewData={getBaseListViewData}
                    getTableViewData={getTableViewData}
                    baseInfoView5Props={{
                        baseInfoView5_1props: {
                            rowKey: rowKey
                        },
                        reloadCount: reloadCount,
                        reloadAndResetCount: reloadAndResetCount
                    }}
                    reloadCount={reloadCount}
                    reloadAndResetCount={reloadAndResetCount}
                />
            </>}
            {/* 無結果提示 */}
            {/* {filteredAndSortedItems.length === 0 && (
                <div className="text-center py-12">
                    <div className="text-gray-400 mb-2">
                        <Search className="h-12 w-12 mx-auto" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-1">找不到相關內容</h3>
                    <p className="text-gray-500">請嘗試調整搜索關鍵字或篩選條件</p>
                </div>
            )} */}
        </div>
    </>)
}
const InfoView = ({
    showComponent = [],
    values,
    baseInfoView4Props,
    baseInfoView5Props,
    baseInfoView6Props,
    viewMode = "卡片模式",
    apiRoute,
    getBaseCardViewData,
    getBaseListViewData,
    getTableViewData,
    searchCount = 0,
    rowKey = "key",
    params = {},
    reloadCount,
    reloadAndResetCount,
    onTotalChange = () => { },
    onSelectChange = () => { },
    proptableDefaultProps,
    extraButtonRender = () => { return [] },
    propsSelectRowKeys = [],
    propsRequest,
}) => {
    const actionRef = useRef();
    const keywordRef = useRef();
    const [extra_columns, set_extra_columns] = useState([]);
    const [pageSize, setPageSize] = useState(20)
    const [selectRows, setSelectRows] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [total, setTotal] = useState(0)
    const [checkedAll, setCheckedAll] = useState(false)
    const [reload, setReload] = useState(0)
    const [thisReload, setThisReload] = useState(0)
    const [thisReloadAndResetCount, setThisReloadAndResetCount] = useState(0)

    // 追蹤 propsSelectRowKeys 前次值，用於變更判斷
    const prevPropsSelectRowKeysRef = useRef([]);

    // 比較兩個陣列是否為同一組 keys（忽略順序）
    const areKeySetsEqual = (a = [], b = []) => {
        if (a.length !== b.length) return false;
        const setA = new Set(a);
        for (const k of b) {
            if (!setA.has(k)) return false;
        }
        return true;
    };

    const onCheckChange = ({ checked, record }) => {
        setSelectedRowKeys((pre) => {
            let newData = [...pre]
            let isSelected = newData?.includes(record?.[rowKey])
            if (!!checked) {
                if (!isSelected) {
                    newData.push(record?.[rowKey])
                }
            }
            else {
                newData = newData.filter((ele) => ele !== record?.[rowKey])
            }
            return newData
        })
        setSelectRows((pre) => {
            let newData = [...pre]
            let isSelected = newData?.find((ele) => ele?.[rowKey] === record?.[rowKey])
            if (!!checked) {
                if (!isSelected) {
                    newData.push(record)
                }
            }
            else {
                newData = newData.filter((ele) => ele?.[rowKey] !== record?.[rowKey])
            }
            if (newData.length === total && total !== 0) {
                setCheckedAll(true)
            } else {
                setCheckedAll(false)
            }
            return newData
        })
    }
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectRows]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.risk_corresponding_resource_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.risk_corresponding_resource_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectRows(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectRows]

            if (selected) {
                select_temp.push(record.risk_corresponding_resource_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.risk_corresponding_resource_id)
                selectRow = selectRow.filter(row => row.risk_corresponding_resource_id !== record.risk_corresponding_resource_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectRows(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const dataController = useCRUDController({
        apiRoute: apiRoute,
        onBefore: ({ }) => {

        },
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === "delete") {
                if (status === "success") {
                    message.success("刪除成功")
                }
                else {
                    message.error("刪除失敗，請稍後再試")
                }
                // 刪除後清空已選擇項目
                setSelectRows([])
                setSelectedRowKeys([])
                setCheckedAll(false)
                setThisReloadAndResetCount(pre => pre + 1)
                // actionRef.current && actionRef.current.reloadAndReset()
            }
        }
    })

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt(proptableDefaultProps.columns || [])
    useEffect(() => {
        onSelectChange(selectRows)
        if (!checkedAll) {
            setReload(pre => pre + 1)
        }
    }, [selectRows])
    useEffect(() => {
        onTotalChange(total)
    }, [total])
    useEffect(() => {
        if (!checkedAll) {
            setSelectRows([])
            setSelectedRowKeys([])
        }
        else {
            setSelectRows(dataController?.ResponseData || [])
            setSelectedRowKeys(dataController?.ResponseData?.map((item) => item?.[rowKey]) || [])
        }
    }, [checkedAll])

    useEffect(() => {
        keywordRef.current = params
    }, [params])
    // propsSelectRowKeys 變動時，更新 selectRows 和 selectedRowKeys（僅在確實變更時觸發）
    useEffect(() => {
        const nextKeys = Array.isArray(propsSelectRowKeys) ? propsSelectRowKeys : [];
        const prevKeys = prevPropsSelectRowKeysRef.current || [];

        // 若沒有實際變更（集合等同），則不進行更新
        if (areKeySetsEqual(nextKeys, prevKeys)) return;

        // 更新前次紀錄
        prevPropsSelectRowKeysRef.current = nextKeys;

        if (nextKeys.length > 0) {
            let selectRowsInfoTemp = nextKeys?.map((key) => {
                return {
                    [rowKey]: key
                }
            })
            setSelectRows(selectRowsInfoTemp);
            setSelectedRowKeys(nextKeys);
            // const fetchSelectedRows = async () => {
            //     try {
            //         const response = await dataController.getData({ [`${rowKey}_arr`]: nextKeys.join(',') });
            //         setSelectRows(response?.data || []);
            //         setSelectedRowKeys(nextKeys);
            //     } catch (error) {
            //         console.error("獲取選中行數據失敗:", error);
            //     }
            // };
        } else {
            setSelectRows([]);
            setSelectedRowKeys([]);
        }
    }, [propsSelectRowKeys]);

    return <Row>
        {/* {baseInfoView4Props?.multipleCheckBox &&
            <Col span={24}>
                 //第三層的checkbox
                {showComponent.includes("BaseInfoView4") && (
                    <BaseInfoView4
                        {...baseInfoView4Props}
                        baseInfoView4_1_props={{
                            ...baseInfoView4Props?.baseInfoView4_1_props,
                            showComponent: ["BaseBulkActionControl1_2", "BaseBulkActionControl1_3"],
                            selectedTotal: total,
                            selectedCount: selectRows.length,
                        }}
                        showComponent={['BaseInfoView4_1']}

                    />
                )}
            </Col>
        } */}
        <Col span={24}>
            <div
                className={cn("rounded-lg p-4  border-l-4")}
                style={{
                    backgroundColor: values?.light_mode_color,
                    borderColor: values?.dark_mode_color
                }}
            >
                {showComponent.includes("BaseInfoView4") && viewMode !== "表格模式" && selectedRowKeys && (
                    <BaseInfoView4
                        // {...baseInfoView4Props}
                        baseInfoView4_1_props={{
                            actionList: [
                                ...(rowKey === "response_id" && baseInfoView4Props?.baseInfoView4_1_props?.baseActionList.includes("批次刪除")) ? [{
                                    label: "批次刪除",
                                    value: "delete_response",
                                    type: "popconfirm",
                                    popconfirmTitle: "確認刪除？",
                                    popconfirmDescription: "您即將對所選項目進行刪除。"
                                }] : [],
                                ...(rowKey === "document_id" && baseInfoView4Props?.baseInfoView4_1_props?.baseActionList.includes("批次刪除")) ? [
                                    {
                                        label: "批次刪除",
                                        value: "delete_document",
                                        type: "popconfirm",
                                        popconfirmTitle: "確認刪除",
                                        popconfirmDescription: "您即將對所選項目進行刪除。"
                                    }] : [],
                            ],

                            ...baseInfoView4Props?.baseInfoView4_1_props,
                            onActionClick: (actionKey) => {
                                if (actionKey === "delete_response") {
                                    let deleteData = selectRows.map((item) => { return { response_id: item?.response_id } })
                                    dataController?.deleteData(deleteData)
                                }
                                else if (actionKey === "delete_document") {
                                    let deleteData = selectRows
                                    dataController?.deleteData(deleteData)
                                }
                                baseInfoView4Props?.baseInfoView4_1_props?.onActionClick &&
                                    baseInfoView4Props?.baseInfoView4_1_props?.onActionClick(actionKey)
                            },
                            checkedAll: checkedAll,
                            onToggleAll: (val) => {
                                setCheckedAll(!!val)
                            },
                            showComponent: ["BaseBulkActionControl1_2", "BaseBulkActionControl1_3", "BaseBulkActionControl1_1"],
                            selectLabel: values?.label || "",
                            selectedTotal: selectedRowKeys.length,
                            selectedCount: selectedRowKeys.length,
                        }}
                        showComponent={['BaseInfoView4_1',]}
                    />
                )}
                {viewMode === "卡片模式" &&
                    showComponent.includes("BaseInfoView5") &&
                    <BaseInfoView5
                        {...baseInfoView5Props}
                        reloadParams={{
                            selectedRowKeys: selectedRowKeys.join(','),
                        }}
                        reloadCount={reloadCount + thisReload}
                        reloadAndResetCount={reloadAndResetCount + thisReloadAndResetCount}
                        key={values?.key}
                        request={propsRequest ? propsRequest : async (tableParams = {}, sort, filter) => {
                            return dataController.getData({ ...tableParams, sort, filter, ...params, })
                        }}

                        baseInfoView5_1props={{
                            rowKey: rowKey,
                            ...baseInfoView5Props?.baseInfoView5_1props,
                            onBaseCardView1CheckChange: (checked, record) => {
                                onCheckChange({ checked, record })
                            }
                        }}

                        getBaseCardViewData={(data) => {
                            let cardData = getBaseCardViewData(data)
                            setSelectRows((pre) => {
                                cardData = cardData.map((cardValue) => {
                                    return {
                                        ...cardValue,
                                        baseCardView1_1Props: {
                                            ...cardValue?.baseCardView1_1Props,
                                            checked: !!pre.find((ele) => ele?.[rowKey] && ele?.[rowKey] === cardValue[rowKey]),
                                        },
                                    }
                                })
                                return pre
                            })
                            return cardData
                        }}
                        showMode='page'
                        reload={reload}
                        searchCount={searchCount}

                    />
                }
                {viewMode === "列表模式" &&
                    showComponent.includes("BaseInfoView6") &&
                    <BaseInfoView6
                        {...baseInfoView6Props}
                        reloadParams={{
                            selectedRowKeys: selectedRowKeys.join(','),
                        }}
                        reloadCount={reloadCount + thisReload}
                        reloadAndResetCount={reloadAndResetCount + thisReloadAndResetCount}
                        key={values?.key}
                        request={propsRequest ? propsRequest : async (tableParams = {}, sort, filter) => {
                            return dataController.getData({ ...tableParams, sort, filter, ...params, })
                        }}
                        baseInfoView6_1props={{
                            rowKey: rowKey,
                            ...baseInfoView6Props?.baseInfoView6_1props,
                            onBaseListView1CheckChange: (checked, record) => {
                                onCheckChange({ checked, record })
                            },
                        }}
                        getBaseListViewData={(data) => {
                            let listData = getBaseListViewData(data)
                            setSelectRows((pre) => {
                                listData = listData.map((listValue) => {
                                    return {
                                        ...listValue,

                                        baseListView1_1Props: {
                                            ...listValue?.baseListView1_1Props,
                                            checked: !!pre.find((ele) => ele?.[rowKey] && ele?.[rowKey] === listValue[rowKey]),
                                        },
                                    }
                                })
                                return pre
                            })

                            return listData
                        }}
                        // getBaseListViewData={getBaseListViewData}
                        showMode='page'
                        searchCount={searchCount}
                        reload={reload}
                    />
                }
                {viewMode === "表格模式" &&
                    showComponent.includes("BaseInfoView6") &&
                    <ProTableOt
                        searchParams={{
                            params,
                            reloadCount,
                            reloadAndResetCount
                        }}
                        actionRef={actionRef}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<></>}
                        rowKey={rowKey}
                        rowSelection={{
                            type: 'checkbox',
                            selectedRowKeys: selectedRowKeys,
                            selectedRowsInfo: selectRows,
                            setSelectedRowKeys: setSelectedRowKeys,
                            setSelectedRowsInfo: setSelectRows,
                            ...rowSelection
                        }}
                        extra_columns={[]}
                        set_extra_columns={() => { }}
                        manage_columns={false}
                        scroll={{
                            x: "100vw"
                        }}
                        toolBarRender={() => {
                            const actions = [
                                ...(baseInfoView4Props?.baseInfoView4_1_props?.actionList || []),
                                ...((rowKey === "response_id" && baseInfoView4Props?.baseInfoView4_1_props?.baseActionList.includes("批次刪除") && selectedRowKeys.length > 0) ? [{
                                    label: "批次刪除",
                                    value: "delete_response",
                                    type: "popconfirm",
                                    popconfirmTitle: "確認刪除？",
                                    popconfirmDescription: "您即將對所選項目進行刪除。"
                                }] : []),
                                ...((rowKey === "document_id" && baseInfoView4Props?.baseInfoView4_1_props?.baseActionList.includes("批次刪除") && selectedRowKeys.length > 0) ? [{
                                    label: "批次刪除",
                                    value: "delete_document",
                                    type: "popconfirm",
                                    popconfirmTitle: "確認刪除",
                                    popconfirmDescription: "您即將對所選項目進行刪除。"
                                }] : []),
                            ]
                            return actions.map((value, idx) => {
                                if (value?.type === "popconfirm") {
                                    return (
                                        <DeleteButton
                                            key={value?.value ?? idx}
                                            onConfirm={() => {
                                                if (value?.value === "delete_response") {
                                                    let deleteData = selectRows.map((item) => { return { response_id: item?.response_id } })
                                                    dataController?.deleteData(deleteData)
                                                }
                                                else if (value?.value === "delete_document") {
                                                    let deleteData = selectRows
                                                    dataController?.deleteData(deleteData)
                                                }
                                                baseInfoView4Props?.baseInfoView4_1_props?.onActionClick &&
                                                    baseInfoView4Props?.baseInfoView4_1_props?.onActionClick(value?.value)
                                            }}
                                            title={value?.popconfirmTitle || "確認執行此操作？"}
                                            description={value?.popconfirmDescription || "您即將對所選項目執行此操作。此操作無法復原。"}
                                        >
                                            {value?.label}
                                        </DeleteButton>
                                    )
                                }
                                return (
                                    <Button
                                        key={value?.value ?? idx}
                                        variant="outline"
                                        size="sm"
                                        onClick={() => {
                                            baseInfoView4Props?.baseInfoView4_1_props?.onActionClick(value?.value)
                                        }}
                                    >
                                        {value?.label}
                                    </Button>
                                )
                            })
                        }}
                        showSearch={false}
                        searchText=""
                        reloadCount={reloadCount + thisReload}
                        reloadAndResetCount={reloadAndResetCount + thisReloadAndResetCount}
                        searchCount={searchCount}

                        {...proptableDefaultProps}
                        request={propsRequest ? propsRequest : async (tableParams = {}, sort, filter) => {
                            let newParams = {
                                ...tableParams,
                                ...params,
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                ...keywordRef.current,
                                order,
                                size: tableParams.pageSize,
                                cur_page: tableParams.current,
                                // custom_filter_value: params.keyword,
                                // custom_filter_key: custom_filter_key
                            }
                            newParams = {
                                ...newParams,
                            }
                            newParams = setParamsFilter({
                                ...newParams,
                            });
                            // Await the API and use the constructed params


                            try {
                                const apiData = await dataController.getData({ ...newParams })
                                return getTableViewData(apiData)
                            } catch (err) {
                                return {
                                    data: [],
                                    total: 0
                                }
                            }
                        }}
                    />
                }
            </div>
        </Col>

    </Row>

}

export default BaseInfoView
